export const OPEN_OVERLAY = 'OVERLAY/OPEN_OVERLAY';
export const CLOSE_OVERLAY = 'OVERLAY/CLOSE_OVERLAY';
export const UPDATE_TITLE = 'OVERLAY/UPDATE_TITLE';
